import { useState } from 'react';

import Card from '../../../components/Card';
import Table from '../../../components/Table';
import Loading from '../../../components/Loading';
import Modal from '../../../components/Modal';
import TopCompanyLabel from '../../../components/TopCompanyLabel';

import {
  transferTop10GoDownByStockUpeData,
  getTop10TooltipContent,
  tradingPeriod,
} from '../Dashboard.helpers';
import { top10GoDownByStockUpHeads } from '../Dashboard.columns';
import * as Styles from '../Dashboard.styles';

const Top10GoUpByStockUp = ({
  isLoading,
  data,
  isDarkMode,
  handleOpenTop10GoUpGoDownTooltip,
  top10GoUpGoDownChartData,
  isInvestmentCategoriesLoading,
  authenticated,
  investmentCategories,
  followCompanies,
  saveInvestmentCategory,
  deleteInvestmentCategory,
  investmentCategoriesMessage,
  isOpeningBookmark,
  handleSetIsOpeningBookmark,
  setSelectedChartPeriod,
  handlesSelectedChartPeriodChange,
  selectedChartPeriod,
  setSelectedDataChartModal,
  setChartModalShow,
  isChartDataByCodeLoading,
}) => {
  const [open, setOpen] = useState(false);
  const [selectedCode, setSelectedCode] = useState('');
  const [companyInfo, setCompanyInfo] = useState(null);
  const [field, setField] = useState('klgd');

  const onChartIconClick = (code, info) => {
    setChartModalShow(true);
    setSelectedDataChartModal({
      code,
      field,
    });
    setOpen(true);
    setSelectedCode(code);
    setCompanyInfo(info);
  };

  const handleCloseModal = () => {
    setOpen(false);
    setSelectedDataChartModal({
      code: '',
      field: '',
    });
    setChartModalShow(false);
    setSelectedChartPeriod(tradingPeriod[0].value);
  };

  const getModalTitle = () => {
    return (
      <div className="flex items-center">
        <span>
          Giá & {field === 'gtgd' ? 'GTGD' : 'KLGD'} - {companyInfo?.code}
        </span>
        <TopCompanyLabel label={companyInfo?.label} />
        <span className="pl-1">- {companyInfo?.name}</span>
      </div>
    );
  };

  return (
    <Card className="sector-item">
      <h4 className="text-sm flex items-center">
        <img
          alt="Tăng"
          src={`/images/a369/tang.png`}
          className="mr-2.5 float-left w-10"
        />
        <span className="inline-block">
          Tăng
          <span className="block font-bold mt-1">
            Các cổ phiếu có mức tăng ấn tượng được lựa chọn bởi Stockup.
          </span>
        </span>
      </h4>
      <div className="mt-2 border-solid border-t-[1px]">
        {isLoading ? <Styles.EmptyTag /> : null}
        <Loading isLoading={isLoading} className="white" />
        {!isLoading ? (
          <Table
            rows={transferTop10GoDownByStockUpeData(
              data,
              'goUp',
              handleOpenTop10GoUpGoDownTooltip,
              isDarkMode,
              top10GoUpGoDownChartData,
              onChartIconClick,
              isInvestmentCategoriesLoading,
              authenticated,
              investmentCategories,
              followCompanies,
              saveInvestmentCategory,
              deleteInvestmentCategory,
              investmentCategoriesMessage,
              isOpeningBookmark,
              handleSetIsOpeningBookmark
            )}
            headCells={top10GoDownByStockUpHeads}
            noBorderStyle
          />
        ) : null}
      </div>
      <Modal
        isOpen={open}
        onCloseModal={handleCloseModal}
        title={getModalTitle()}
        mainContentClassName="modal-center max-w-[96vw] md:max-w-[70vw] m-auto w-full"
        childrenWrapperClassName=""
      >
        <div className="w-full main-content">
          {getTop10TooltipContent(
            top10GoUpGoDownChartData,
            field,
            selectedCode,
            field === 'gtgd' ? 'GTGD' : 'KLGD',
            field === 'gtgd' ? ' tỷ' : 'cp',
            isDarkMode,
            'modal',
            '350px',
            70,
            handlesSelectedChartPeriodChange,
            selectedChartPeriod,
            setField,
            isChartDataByCodeLoading
          )}
        </div>
      </Modal>
    </Card>
  );
};

export default Top10GoUpByStockUp;
